module.exports = __webpack_public_path__ + "img/NoTextImg.a51bace7.png";